import { render, staticRenderFns } from "./zhuanticomment.vue?vue&type=template&id=bbee0e52&"
import script from "./zhuanticomment.vue?vue&type=script&lang=js&"
export * from "./zhuanticomment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports